;(function () {
	function initCardGallery(cardWrapper) {
		const gallery = cardWrapper.querySelector('.ec-card-gallery')
		if (!gallery) return

		const images = gallery.querySelectorAll('.ec-card-gallery__image')
		if (images.length <= 1) return

		const controls = gallery.querySelector('.ec-card-gallery__controls')
		if (!controls) return

		const dots = gallery.querySelectorAll('.ec-card-gallery__dot')
		const prevBtn = gallery.querySelector('.ec-card-gallery__arrow--prev')
		const nextBtn = gallery.querySelector('.ec-card-gallery__arrow--next')
		const scrollbarTrack = gallery.querySelector('.ec-card-gallery__scrollbar-track')
		const scrollbarDrag = gallery.querySelector('.ec-card-gallery__scrollbar-drag')

		if (!prevBtn && !nextBtn && dots.length === 0 && !scrollbarTrack) return

		if (gallery.dataset.ecCardGalleryBound === '1') return
		gallery.dataset.ecCardGalleryBound = '1'

		if (gallery._ecGalleryAbort) {
			try {
				gallery._ecGalleryAbort.abort()
			} catch (err) {}
		}
		const ac = new AbortController()
		gallery._ecGalleryAbort = ac
		const docSignal = { signal: ac.signal }

		let currentIndex = 0
		let isDragging = false
		let dragStartX = 0
		let dragStartLeft = 0
		let isImageDragging = false
		let imageDragStartX = null
		let imageDragStartY = null
		const imageDragThreshold = 30
		let imageDragStarted = false
		let lastImageChangeTime = 0

		function calculateDragSize() {
			if (!scrollbarDrag || !scrollbarTrack) return 0
			const trackWidth = scrollbarTrack.offsetWidth
			const dragSize = Math.max(60, trackWidth / images.length)
			return dragSize
		}

		function updateScrollbar() {
			if (!scrollbarDrag || !scrollbarTrack || images.length <= 1) return
			const trackWidth = scrollbarTrack.offsetWidth
			const dragSize = calculateDragSize()
			const maxLeft = trackWidth - dragSize
			const left = (currentIndex / (images.length - 1)) * maxLeft

			scrollbarDrag.style.width = dragSize + 'px'
			scrollbarDrag.style.left = left + 'px'
		}

		function showImage(index) {
			currentIndex = Math.max(0, Math.min(index, images.length - 1))

			images.forEach((img, i) => {
				if (i === currentIndex) {
					img.classList.add('ec-card-gallery__image--active')
				} else {
					img.classList.remove('ec-card-gallery__image--active')
				}
			})

			dots.forEach((dot, i) => {
				if (i === currentIndex) {
					dot.classList.add('ec-card-gallery__dot--active')
				} else {
					dot.classList.remove('ec-card-gallery__dot--active')
				}
			})

			if (gallery.hasAttribute('data-current-index')) {
				gallery.dataset.currentIndex = String(currentIndex)
			}

			updateScrollbar()
		}

		function nextImage() {
			const nextIndex = (currentIndex + 1) % images.length
			showImage(nextIndex)
		}

		function prevImage() {
			const prevIndex = (currentIndex - 1 + images.length) % images.length
			showImage(prevIndex)
		}

		function handleControlEvent(e, callback) {
			e.preventDefault()
			e.stopPropagation()
			e.stopImmediatePropagation()
			if (callback) callback()
		}

		if (nextBtn) {
			nextBtn.addEventListener(
				'click',
				function (e) {
					handleControlEvent(e, nextImage)
				},
				{ capture: true, signal: ac.signal }
			)
		}

		if (prevBtn) {
			prevBtn.addEventListener(
				'click',
				function (e) {
					handleControlEvent(e, prevImage)
				},
				{ capture: true, signal: ac.signal }
			)
		}

		dots.forEach((dot, index) => {
			dot.addEventListener(
				'click',
				function (e) {
					handleControlEvent(e, function () {
						showImage(index)
					})
				},
				{ capture: true, signal: ac.signal }
			)
		})

		const imagesContainer = gallery.querySelector('.ec-card-gallery__images')
		if (imagesContainer) {
			let touchStartTime = 0
			let hasMoved = false
			let isMobile = window.innerWidth <= 749

			function checkIfMobile() {
				isMobile = window.innerWidth <= 749
			}

			window.addEventListener('resize', checkIfMobile, docSignal)

			function handleImageDragStart(e) {
				if (!isMobile) return

				const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX
				const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY
				imageDragStartX = clientX
				imageDragStartY = clientY
				isImageDragging = false
				imageDragStarted = false
				hasMoved = false
				touchStartTime = Date.now()
			}

			function handleImageDragMove(e) {
				if (!isMobile) return
				if (imageDragStartX === null && imageDragStartY === null) return

				const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX
				const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY
				const deltaX = clientX - imageDragStartX
				const deltaY = clientY - imageDragStartY
				const absDeltaX = Math.abs(deltaX)
				const absDeltaY = Math.abs(deltaY)

				if (absDeltaX > 10 || absDeltaY > 10) {
					hasMoved = true
				}

				if (absDeltaX > 5 && absDeltaX > absDeltaY) {
					if (!isImageDragging) {
						isImageDragging = true
						imageDragStarted = true
					}
					e.preventDefault()
					e.stopPropagation()

					if (absDeltaX > imageDragThreshold) {
						const now = Date.now()
						if (now - lastImageChangeTime > 150) {
							if (deltaX > 0) {
								prevImage()
								lastImageChangeTime = now
								imageDragStartX = clientX
							} else {
								nextImage()
								lastImageChangeTime = now
								imageDragStartX = clientX
							}
						}
					}
				}
			}

			function handleImageDragEnd(e) {
				if (!isMobile) return

				if (isImageDragging || imageDragStarted) {
					e.preventDefault()
					e.stopPropagation()
					setTimeout(function () {
						imageDragStartX = null
						imageDragStartY = null
						isImageDragging = false
						imageDragStarted = false
						hasMoved = false
					}, 200)
				} else {
					setTimeout(function () {
						imageDragStartX = null
						imageDragStartY = null
						isImageDragging = false
						imageDragStarted = false
						hasMoved = false
					}, 50)
				}
			}

			imagesContainer.addEventListener('touchstart', handleImageDragStart, { passive: true, capture: false, signal: ac.signal })
			imagesContainer.addEventListener('touchmove', handleImageDragMove, { passive: false, capture: true, signal: ac.signal })
			imagesContainer.addEventListener('touchend', handleImageDragEnd, { passive: false, capture: true, signal: ac.signal })
			imagesContainer.addEventListener('touchcancel', handleImageDragEnd, { passive: false, capture: true, signal: ac.signal })

			imagesContainer.addEventListener('mousedown', handleImageDragStart, { capture: false, signal: ac.signal })
			imagesContainer.addEventListener('mousemove', handleImageDragMove, { capture: true, signal: ac.signal })
			imagesContainer.addEventListener('mouseup', handleImageDragEnd, { capture: true, signal: ac.signal })
			imagesContainer.addEventListener('mouseleave', handleImageDragEnd, { capture: true, signal: ac.signal })
		}

		if (scrollbarTrack && scrollbarDrag) {
			function stopToParentSwiper(e) {
				e.stopPropagation()
				e.stopImmediatePropagation()
			}

			function getIndexFromPosition(clientX) {
				const rect = scrollbarTrack.getBoundingClientRect()
				const trackWidth = rect.width
				const dragSize = calculateDragSize()
				const maxLeft = trackWidth - dragSize
				const relativeX = clientX - rect.left
				const clampedX = Math.max(0, Math.min(relativeX, maxLeft))
				const progress = maxLeft > 0 ? clampedX / maxLeft : 0
				return Math.round(progress * (images.length - 1))
			}

			scrollbarTrack.addEventListener(
				'click',
				function (e) {
					if (e.target === scrollbarDrag) return
					stopToParentSwiper(e)
					const index = getIndexFromPosition(e.clientX)
					showImage(index)
				},
				docSignal
			)

			scrollbarTrack.addEventListener(
				'touchend',
				function (e) {
					if (e.target === scrollbarDrag || isDragging) return
					if (e.changedTouches.length === 0) return
					stopToParentSwiper(e)
					const index = getIndexFromPosition(e.changedTouches[0].clientX)
					showImage(index)
				},
				{ signal: ac.signal, capture: true, passive: false }
			)

			scrollbarDrag.addEventListener(
				'mousedown',
				function (e) {
					e.preventDefault()
					e.stopPropagation()
					isDragging = true
					dragStartX = e.clientX
					dragStartLeft = parseFloat(scrollbarDrag.style.left) || 0
				},
				docSignal
			)

			document.addEventListener(
				'mousemove',
				function (e) {
					if (!isDragging || !scrollbarDrag || !scrollbarTrack) return
					e.preventDefault()
					e.stopPropagation()
					const rect = scrollbarTrack.getBoundingClientRect()
					const trackWidth = rect.width
					const dragSize = calculateDragSize()
					const maxLeft = trackWidth - dragSize
					const deltaX = e.clientX - dragStartX
					let newLeft = dragStartLeft + deltaX
					newLeft = Math.max(0, Math.min(newLeft, maxLeft))
					scrollbarDrag.style.left = newLeft + 'px'

					const progress = maxLeft > 0 ? newLeft / maxLeft : 0
					const index = Math.round(progress * (images.length - 1))
					if (index !== currentIndex) {
						showImage(index)
					}
				},
				docSignal
			)

			document.addEventListener(
				'mouseup',
				function () {
					if (isDragging) {
						isDragging = false
						updateScrollbar()
					}
				},
				docSignal
			)

			scrollbarDrag.addEventListener(
				'touchstart',
				function (e) {
					e.preventDefault()
					stopToParentSwiper(e)
					isDragging = true
					dragStartX = e.touches[0].clientX
					dragStartLeft = parseFloat(scrollbarDrag.style.left) || 0
				},
				{ signal: ac.signal, capture: true, passive: false }
			)

			document.addEventListener(
				'touchmove',
				function (e) {
					if (!isDragging || !scrollbarDrag || !scrollbarTrack) return
					e.preventDefault()
					stopToParentSwiper(e)
					const rect = scrollbarTrack.getBoundingClientRect()
					const trackWidth = rect.width
					const dragSize = calculateDragSize()
					const maxLeft = trackWidth - dragSize
					const deltaX = e.touches[0].clientX - dragStartX
					let newLeft = dragStartLeft + deltaX
					newLeft = Math.max(0, Math.min(newLeft, maxLeft))
					scrollbarDrag.style.left = newLeft + 'px'

					const progress = maxLeft > 0 ? newLeft / maxLeft : 0
					const index = Math.round(progress * (images.length - 1))
					if (index !== currentIndex) {
						showImage(index)
					}
				},
				{ signal: ac.signal, capture: true, passive: false }
			)

			document.addEventListener(
				'touchend',
				function (e) {
					if (isDragging) {
						e.preventDefault()
						stopToParentSwiper(e)
						isDragging = false
						updateScrollbar()
					}
				},
				{ signal: ac.signal, capture: true, passive: false }
			)

			window.addEventListener(
				'resize',
				function () {
					updateScrollbar()
				},
				docSignal
			)

			updateScrollbar()
		}

		const cardLinks = cardWrapper.querySelectorAll('.full-unstyled-link')

		function shouldPreventClick(e) {
			const target = e.target
			if (
				target.closest('.ec-card-gallery__arrow') ||
				target.closest('.ec-card-gallery__dot') ||
				target.closest('.ec-card-gallery__controls button') ||
				target.closest('.ec-card-gallery__scrollbar--mobile') ||
				target.closest('.ec-card-gallery__scrollbar-track') ||
				target.closest('.ec-card-gallery__scrollbar-drag')
			) {
				return true
			}
			if (imageDragStarted || isImageDragging) {
				return true
			}
			return false
		}

		cardLinks.forEach(function (cardLink) {
			if (cardLink) {
				cardLink.onclick = function (e) {
					if (shouldPreventClick(e)) {
						e.preventDefault()
						e.stopPropagation()
						e.stopImmediatePropagation()
						return false
					}
				}
			}
		})

		cardWrapper.onclick = function (e) {
			if (shouldPreventClick(e)) {
				e.preventDefault()
				e.stopPropagation()
				e.stopImmediatePropagation()
				return false
			}
		}
	}

	function initAllCardGalleries() {
		document.querySelectorAll('.product-card-wrapper').forEach(initCardGallery)
	}

	window.shopifyEcInitCardGalleriesIn = function (root) {
		const scope = root && root.querySelectorAll ? root : document
		scope.querySelectorAll('.product-card-wrapper').forEach(initCardGallery)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAllCardGalleries)
	} else {
		initAllCardGalleries()
	}

	if (typeof Shopify !== 'undefined' && Shopify.designMode) {
		document.addEventListener('shopify:section:load', initAllCardGalleries)
	}
})()
